import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CloseTime = 3000;

export default class AlertService {
  static success = (message: string, closeTime?: number) => {
    return toast.success(message, {
      autoClose: closeTime ?? CloseTime,
      closeOnClick: true,
    });
  };

  static error = (message: string, closeTime?: number) => {
    return toast.error(message, {
      autoClose: closeTime ?? CloseTime,
      closeOnClick: true,
    });
  };
  static info = (message: string, closeTime?: number) => {
    return toast.info(message, {
      autoClose: closeTime ?? CloseTime,
      closeOnClick: true,
    });
  };

  static warning = (message: string, closeTime?: number) => {
    return toast.warn(message, {
      autoClose: closeTime ?? CloseTime,
      closeOnClick: true,
    });
  };
}
